import {
  Form,
  onFieldInputValueChange,
  onFieldReact
} from '@eastcoal/formily/exports/core'

import { AnnouncementType } from '@eastcoal/shared/enums/AnnouncementType'

import {
  KIND_FIELD,
  MEMBER_FIELD,
  ANNOUNCEMENT_FIELD
} from '../../constants/field'

/**
 * “竞价预告”联动逻辑
 */
const updateState = (_: unknown, form: Form) => {
  const { memberId, kindId } = form.values
  const disabled = !(memberId && kindId) || !form.editable
  form.setFieldState(ANNOUNCEMENT_FIELD, state => {
    state.disabled = disabled
    state.componentProps = {
      readyRequest: !disabled,
      memberId: memberId,
      kindId,
      type: AnnouncementType.APPLY
    }
  })
}

const clearValue = (_: unknown, form: Form) => {
  form.setFieldState(ANNOUNCEMENT_FIELD, state => {
    state.value = null
  })
}

export const announcementEffect = () => {
  onFieldReact(MEMBER_FIELD, updateState)
  onFieldReact(KIND_FIELD, updateState)
  onFieldInputValueChange(MEMBER_FIELD, clearValue)
  onFieldInputValueChange(KIND_FIELD, clearValue)
}
